module.exports = __webpack_public_path__ + "static/media/job.31372da5.svg";